import $ from 'jquery';
import View from 'mixins/view';
import { siteModel } from 'models/SiteModel';
import { scroller as loginBarScroller } from '@ui/login-bar/scroller';

export const elements = {
    loaderContainer: '.c-comments__loader-container',
    recommendContainer: '.c-comments__recommend-container',
    ratingContainer: '.c-comments__rating-container',
};

export default class extends View {
    constructor(model) {
        super(model);

        this.setRootEl($('<aside class="rmpl-flex-container rmpl-flex-aligned c-comments__action"></aside>'));
        this.popularCommentRating = 5;

        /*
        const refresh = (event) => {
            if (model.get('id') === Number(event.detail.id)) {
                this.setModel(event.detail.model);
                this.render();
                this.blockedClick = false;
            }
        };
        this.getRootEl().on('RefreshComment', refresh);
        */
    }

    setRatingColor() {
        const rating = this.getModel().get('likesCount');
        const isLikedByUser = this.getModel().get('isLikedByUser');

        if (rating >= this.popularCommentRating) {
            this.ratingColor = 'green';
        } else if (rating < this.popularCommentRating && isLikedByUser) {
            this.ratingColor = 'apporange';
        } else {
            this.ratingColor = 'lightgrey';
        }
    }

    setRatingCountEl() {
        this.ratingCountEl = $(`
            <strong class="text-color_${this.ratingColor}">
                ${ this.getModel().get('likesCount') }
            </strong>
        `);
    }
    setRatingTriggerEl() {
        this.ratingTriggerEl = $(`
            <i class="icon-size_2-like-color_${
                this.getModel()
                    .get('isLikedByUser')
                    ? 'apporange'
                    : 'lightgrey'
                }"></i>
        `);
    }
    setRecommendedTriggerEl() {
        this.recommendTriggerEl = $(`
            <i class="icon-size_2-star-color_apporange ${
                this.getModel().get('isRecommended')
                    ? ''
                    : 'hide'
                }"></i>
        `);
    }
    captureTriggerClick(event) {
        event.preventDefault();
        event.stopPropagation();

        if (!siteModel.isUserLogged()) {
            this.ratingTriggerEl.addClass('js-BubbleBox-Call');
            loginBarScroller();
            return;
        }

        const id = this.model.get('id');
        const likeCommentEvent = new CustomEvent('LikeComment', {
            detail: {
                id,
                value: this.model.get('isLikedByUser'),
            },
        });
        document.dispatchEvent(likeCommentEvent);
    }

    render() {
        this.setRatingColor();
        this.setRecommendedTriggerEl();
        this.setRatingCountEl();
        this.setRatingTriggerEl();

        this.ratingTriggerEl.click(this.captureTriggerClick.bind(this));

        this.getRootEl().html(`
            <span class="rmpl-flex-item-auto ${elements.loaderContainer.substr(1)} box-inline shift-margin_1-left">
            </span>
            <span class="rmpl-flex-item-auto ${elements.recommendContainer.substr(1)} box-inline shift-margin_1-left">
            </span>
            <span class="rmpl-flex-item-auto ${elements.ratingContainer.substr(1)} box-inline">
            </span>
        `);

        this.rootEl
            .find(elements.recommendContainer)
            .append(this.recommendTriggerEl);

        this.rootEl
            .find(elements.ratingContainer)
            .append(this.ratingCountEl, this.ratingTriggerEl);
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/comment-rating-actions-view.js